export default __webpack_public_path__ + "static/countryBackground-20bd768ca6d67580eb327c4247d05f5f.png";